import '../assets/icons/';

import RtButton from './button/rtButton';
import RtButtonGroup from './button/rtButtonGroup';
import RtView from './layout/rtView';
import RtHeader from './layout/rtHeader';
import RtContent from './layout/rtContent';
import RtFooter from './layout/rtFooter';
import RtLookup from './lookup';
import RtPicklist from './picklist';
import RtCard from './card/rtCard.vue';
import RtSection from './section/rtSection.vue';
import RtIcon from './icon/rtIcon';
import RtTag from './tag/rtTag';
import RtForm from './form/rtForm';
import RtFormItem from './form/rtFormItem';
import RtInput from './form/rtInput';
import RtDatePicker from './form/rtDatePicker';

import RtRow from './row/rtRow';
import RtCol from './col/rtCol';
import RtTable from './table/rtTable';
import RtTableColumn from './table/rtTableColumn.js';
import RtTableDropdown from './table/rtTableDropdown';
import RtAdvanceTableGroup from './table/rtAdvanceTableGroup';
import RtAdvanceTableItem from './table/rtAdvanceTableItem';

import RtSearch from './search/rtSearch';

import RtTabs from './tab/rtTabs';
import RtContentTabs from './tab/rtContentTabs';
import RtTabPane from './tab/rtTabPane';

import RtHeaderButtonGroup from './business/common/rtHeaderButtonGroup';
import RtHeaderIcon from './business/common/rtHeaderIcon';
import RtHeaderTitle from './business/common/rtHeaderTitle';
import RtAttr from './business/common/rtAttr';

import RtDetailHeader from './business/detail/rtDetailHeader';
import RtDetailItem from './business/detail/rtDetailItem';
import RtDetailAside from './business/detail/rtDetailAside';

import RtListHeader from './business/list/rtListHeader';
import RtListFilter from './business/list/rtListFilter';

import RtDropDown from './dropdown/rtDropdown.vue';
import RtDropDownMenu from './dropdown/rtDropdownMenu.vue';
import RtDropDownItem from './dropdown/rtDropdownItem.vue';

import RtRadioGroup from './radio/rtRadioGroup.vue';
import RtRadio from './radio/rtRadio.vue';
import RtRadioButton from './radio/rtRadioButton.vue';

import RtCheckboxGroup from './checkbox/rtCheckboxGroup.vue';
import RtCheckbox from './checkbox/rtCheckbox.vue';
import RtCheckboxButton from './checkbox/rtCheckboxButton.vue';

import RtTree from './tree/rtTree.js';
import RtUpload from './upload/rtUpload.js';

import RtLabelGroup from './label/rtLabelGroup.vue';
import RtLabelItem from './label/rtLabelItem.vue';

import RtDialog from './dialog/rtDialog.vue';

import RtCollapseTransition from './collapse/rtCollapseTransition.vue';
import RtCollapse from './collapse/rtCollapse.vue';

import RtAttachment from './attachment/rtAttachment.vue';

import RtApproval from './approval/rtApproval.vue';
import RtApprovalItem from './approval/rtApprovalItem.vue';

import RtCascader from './cascader/rtCascader.vue';

import RtAddress from './cascader/rtAddress.vue';

import ElementUI from 'element-ui'; // 按需引入 elementui 组件
import 'element-ui/lib/theme-chalk/index.css';
// elementui 按需引入，多语言设置 https://element.eleme.cn/2.13/#/zh-CN/component/i18n
import ElementLocale from 'element-ui/lib/locale';

// 自定义 plugins
import { plugins } from '../plugins';

// 全部默认配置参数
import xpcConfig from '../config';

// eslint-disable-next-line prettier/prettier
const components = [
  { name: RtButton.name, component: RtButton },
  { name: RtButtonGroup.name, component: RtButtonGroup },
  { name: RtView.name, component: RtView },
  { name: RtHeader.name, component: RtHeader },
  { name: RtContent.name, component: RtContent },
  { name: RtFooter.name, component: RtFooter },
  { name: RtLookup.name, component: RtLookup },
  { name: RtPicklist.name, component: RtPicklist },
  { name: RtCard.name, component: RtCard },
  { name: RtSection.name, component: RtSection },
  { name: RtIcon.name, component: RtIcon },
  { name: RtTag.name, component: RtTag },
  { name: RtForm.name, component: RtForm },
  { name: RtFormItem.name, component: RtFormItem },
  { name: RtInput.name, component: RtInput },
  { name: RtDatePicker.name, component: RtDatePicker },
  { name: RtRow.name, component: RtRow },
  { name: RtCol.name, component: RtCol },

  { name: RtTable.name, component: RtTable },
  { name: RtTableColumn.name, component: RtTableColumn },
  { name: RtTableDropdown.name, component: RtTableDropdown },
  { name: RtAdvanceTableGroup.name, component: RtAdvanceTableGroup },
  { name: RtAdvanceTableItem.name, component: RtAdvanceTableItem },

  { name: RtSearch.name, component: RtSearch },

  { name: RtTabs.name, component: RtTabs },
  { name: RtContentTabs.name, component: RtContentTabs },
  { name: RtTabPane.name, component: RtTabPane },

  { name: RtHeaderButtonGroup.name, component: RtHeaderButtonGroup },
  { name: RtHeaderIcon.name, component: RtHeaderIcon },
  { name: RtHeaderTitle.name, component: RtHeaderTitle },
  { name: RtAttr.name, component: RtAttr },

  { name: RtDetailHeader.name, component: RtDetailHeader },
  { name: RtDetailItem.name, component: RtDetailItem },
  { name: RtDetailAside.name, component: RtDetailAside },
  { name: RtListFilter.name, component: RtListFilter },
  { name: RtListHeader.name, component: RtListHeader },

  { name: RtDropDown.name, component: RtDropDown },
  { name: RtDropDownMenu.name, component: RtDropDownMenu },
  { name: RtDropDownItem.name, component: RtDropDownItem },

  { name: RtRadioGroup.name, component: RtRadioGroup },
  { name: RtRadio.name, component: RtRadio },
  { name: RtRadioButton.name, component: RtRadioButton },

  { name: RtCheckboxGroup.name, component: RtCheckboxGroup },
  { name: RtCheckbox.name, component: RtCheckbox },
  { name: RtCheckboxButton.name, component: RtCheckboxButton },
  { name: RtTree.name, component: RtTree },
  { name: RtUpload.name, component: RtUpload },

  { name: RtLabelGroup.name, component: RtLabelGroup },
  { name: RtLabelItem.name, component: RtLabelItem },

  { name: RtDialog.name, component: RtDialog },

  { name: RtCollapseTransition.name, component: RtCollapseTransition },
  { name: RtCollapse.name, component: RtCollapse },

  { name: RtAttachment.name, component: RtAttachment },

  { name: RtApproval.name, component: RtApproval },
  { name: RtApprovalItem.name, component: RtApprovalItem },

  { name: RtCascader.name, component: RtCascader },
  { name: RtAddress.name, component: RtAddress }
];

const installComponents = (Vue, componentPrefix = 'Rt') => {
  // xpc 组件全局注册
  components.forEach(item => {
    // 组件重命名，防止同名覆盖
    const componentName = item.name.replace('Rt', componentPrefix);
    Vue.component(componentName, item.component);
  });
};

const installPlugins = (Vue, opts) => {
  // xpc 组件多语言设置
  plugins.forEach(item => Vue.use(item, opts));
};

const install = (Vue, opts) => {
  let { i18n, config } = opts;

  // 合并全局配置参数
  xpcConfig.assign(config);

  // elementui 多语言设置
  if (i18n) {
    Vue.use(ElementUI, {
      i18n: (key, value) => i18n.t(key, value)
    });
  } else {
    Vue.use(ElementUI);
  }
  // 注册 plugins
  installPlugins(Vue, opts);

  // 注册 components
  let { componentPrefix } = xpcConfig.get();
  installComponents(Vue, componentPrefix);
};

export default {
  install,
  getComponents() {
    return components;
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/index.js